exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-main-clas[data-v-b4aa35ec]{position:relative}", ""]);

// exports
